import React, { useEffect } from "react";
import {
    useFormContext,
    useWatch,
} from "react-hook-form";
import moment from "moment";

import { MedicalFields, MedicalKeys } from "../../../../enums/MedicalReportEnums";
import { FieldRenderer } from "../FieldRenderer/FieldRenderer";
import { getDateByRadio, getDateValue } from "./utils";

interface StatisticChildProps {
    field: any;
    child: any;
}

const StatisticChild: React.FC<StatisticChildProps> = ({
    field,
    child,
}) => {
    const methods = useFormContext();


    const repeatedValue = useWatch({
        control: methods.control,
        name: `Attributes.${field.Id}`,
    });

    const lKeys = child?.Key?.split(".");


    const repeatedStat =
        field?.InverseParentStepFields?.find(
            (item: any) =>
                item?.Key === lKeys?.[0]
        );


    const countParentChild = (
        values: Record<string, string | number>[],
        parentId: number,
        childId: number
    ): number | undefined => {
        if (!Array.isArray(values)) {
            return undefined;
        }

        const valueLength = values.filter(
            (item) =>
                Number(
                    item?.[String(parentId)]
                ) === Number(childId)
        ).length
        return valueLength > 0 ? valueLength : undefined;
    };






    useEffect(() => {
        if (!repeatedStat) return;

        let value: string | number | undefined;

        if (repeatedStat.Type === MedicalFields.Radio) {
            const childId = repeatedStat?.InverseParentStepFields?.find(
                (f: any) => f?.Key === lKeys?.[1]
            )?.Id;

            value = childId !== undefined
                ? countParentChild(repeatedValue ?? [], repeatedStat.Id, childId)
                : undefined;
        }

        if (
            repeatedStat.Type === MedicalFields.Date ||
            repeatedStat.Type === MedicalFields.PastDate ||
            repeatedStat.Type === MedicalFields.FutureDate
        ) {





            const radioField = field?.InverseParentStepFields?.find(
                (f: any) => f?.Type === MedicalFields.Radio
            );

            if (radioField) {
                value = getDateByRadio(
                    repeatedValue ?? [],
                    radioField,
                    MedicalKeys.Cesarean,
                    repeatedStat.Id,
                    lKeys?.[1]
                ) ?? "";
            } else {
                value = getDateValue(repeatedValue ?? [], repeatedStat.Id, lKeys?.[1]);
            }
        }

        methods.setValue(`Attributes.${child.Id}`, value);
    }, [repeatedValue, repeatedStat, child.Id, lKeys?.[1]]);



    return (
        <FieldRenderer
            key={child.Id}
            disabled
            field={{
                ...child,
                Key: undefined,
                Type: MedicalFields.Text,
            }}
        />
    );
};

export default StatisticChild;